import { Route, Routes, Navigate } from 'react-router-dom'
// import Illustrations from './Illustrations'
import StoryboardProjects from './SBProjects'
import Landing from './Landing'
import Pixelart from './Pixel'
import Contact from './Contact'
import JustifiedGallery from './JustifiedGallery'
import { illustrations } from "../images"
import '../css/Content.css'


export default function Content({viewOn, setOverlayState}) {
    return (
      <div className="content">
        <Routes>
          <Route path="*" element={<Navigate to="/" element={<Landing />} replace />}></Route>
            <Route path="/" element={<Landing />} />
            <Route exact path ='/storyboarding' element={<StoryboardProjects viewOn={viewOn} setOverlayState={setOverlayState} />}></Route>
            <Route exact path='/illustration' element={<JustifiedGallery viewOn={viewOn} setOverlayState={setOverlayState} images={illustrations} />}></Route>
            <Route exact path ='/pixelart' element={<Pixelart viewOn={viewOn} setOverlayState={setOverlayState} />}></Route>
            <Route exact path='/contact' element={<Contact />}></Route>
        </Routes>
      </div>
    )
}
